import { motion } from 'framer-motion';
import { Section, SectionHeader } from '@/components/ui/Section';
import { featureImages } from '@/config/site';
import { cn } from '@/lib/utils';

export function FeaturesSection() {
  return (
    <Section id="features" className="bg-muted/30">
      <SectionHeader
        subtitle="Fitur"
        title="Explore Our World"
        description="Jelajahi berbagai fitur dan konten menarik yang menanti kamu di Hytale Indonesia."
      />

      <div className="space-y-24">
        {featureImages.map((feature, index) => {
          const isReversed = index % 2 === 1;

          return (
            <motion.div
              key={feature.id}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 0.6, ease: 'easeOut' }}
              className={cn(
                'grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center',
                isReversed && 'md:[&>*:first-child]:order-2'
              )}
            >
              {/* Image */}
              <motion.div
                initial={{ opacity: 0, x: isReversed ? 20 : -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
                className="flex justify-center"
              >
                <div className="relative w-[80%] md:w-full max-w-lg">
                  <div className="absolute inset-0 bg-primary/20 blur-3xl rounded-full" />
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="relative rounded-xl shadow-lg border border-border/50 w-full object-cover aspect-video"
                    loading="lazy"
                  />
                </div>
              </motion.div>

              {/* Content */}
              <motion.div
                initial={{ opacity: 0, x: isReversed ? -20 : 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.3 }}
                className={cn(
                  'text-center md:text-left',
                  isReversed && 'md:text-right'
                )}
              >
                <span className="text-sm font-medium text-primary uppercase tracking-wider">
                  Feature {index + 1}
                </span>
                <h3 className="font-display text-2xl sm:text-3xl font-bold text-foreground mt-2 mb-4">
                  {feature.title}
                </h3>
                <p className="text-muted-foreground text-base md:text-lg">
                  {feature.description}
                </p>
              </motion.div>
            </motion.div>
          );
        })}
      </div>
    </Section>
  );
}
